/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/factory 层；
 * 2. 负责定义特征结果体/预览体对象工厂的统一抽象；
 * 3. 该抽象用于隔离 MeshManager 与各特征专属对象的具体构造细节。
 *
 * 文件职责：
 * 1. 定义特征 mesh 对象工厂输入协议；
 * 2. 定义特征 mesh 对象工厂统一抽象；
 * 3. 为后续新增 sweep、loft、cut 等特征提供可注册扩展点。
 */

import * as THREE from 'three';
import type {FeatureDefinition} from '../../../feature/definition/FeatureDefinition';
import type {FeaturePrototype} from '../../../feature/prototype/FeaturePrototype';/**
 * 特征 mesh 构建上下文。
 */
export interface FeatureMeshBuildContext {
    /** 目标特征原型。 */
    prototype?: FeaturePrototype | null;
    /** 当前草稿定义。 */
    draftDefinition?: FeatureDefinition | null;
}

/**
 * 特征 mesh 对象构建输入。
 */
export interface FeatureMeshObjectBuildInput {
    /** 网格数据。 */
    meshData: MeshData;
    /** 几何体。 */
    geometry: THREE.BufferGeometry;
    /** 材质。 */
    material: THREE.Material | THREE.Material[];
    /** 是否为预览体。 */
    isPreview: boolean;
    /** 构建上下文。 */
    context?: FeatureMeshBuildContext;
}

/**
 * 特征 mesh 对象工厂抽象。
 */
export abstract class FeatureMeshObjectFactory {
    /**
     * 根据输入尝试创建专属特征 mesh 对象。
     * @param input 构建输入。
     * @returns 命中时返回专属 mesh，未命中返回 null。
     */
    public abstract create(input: FeatureMeshObjectBuildInput): THREE.Mesh | null;
}
